import React, { FC, ReactElement, useContext, useMemo } from 'react';
import { Box, Card, Text, Grid, ResponsiveContext } from 'grommet';
import { BaseComponentProps } from '@/types';
import { DepartmentOfDefense } from '@/icons/DepartmentOfDefense';
import { Amazon } from '@/icons/Amazon';
import { PayPal } from '@/icons/PayPal';
import { Uber } from '@/icons/Uber';

export const LogoWrapper: FC<BaseComponentProps> = ({
  children,
}): ReactElement => {
  const size = useContext(ResponsiveContext);
  const isSmall = useMemo(() => size === `small`, [size]);
  return (
    <Card
      pad={isSmall ? `large` : `medium`}
      style={{ zIndex: 1 }}
      round="small"
      align="center"
      justify="center"
      background={{ light: `light-2`, dark: `dark-2` }}
    >
      {children}
    </Card>
  );
};

export const TrustedBy: FC = (): ReactElement => (
  <Box>
    <Text alignSelf="center" weight="bold" style={{ zIndex: 1 }}>
      OUR TEAM HAS HELPED PROTECT
    </Text>
    <Grid
      pad={{ horizontal: `medium` }}
      columns={{ count: `fit`, size: `small` }}
      rows="xsmall"
      gap="medium"
      margin={{ top: `medium` }}
    >
      <LogoWrapper>
        <DepartmentOfDefense />
      </LogoWrapper>
      <LogoWrapper>
        <Amazon />
      </LogoWrapper>
      {/* TODO: Pending new asset for Florida? */}
      {/* <LogoWrapper>
        <Image src="/img/logos/florida.webp" />
      </LogoWrapper> */}
      <LogoWrapper>
        <PayPal />
      </LogoWrapper>
      <LogoWrapper>
        <Uber />
      </LogoWrapper>
    </Grid>
  </Box>
);
